export const AlertTypeLabel = {
  LicenseChanged: 'License Changed',
  LicenseExpiresSoon: 'License Expires Soon',
  LicenseExpired: 'License Expired',
  NpiRecordChanged: 'NPI Record Changed',
  Review: 'Needs Review'
};

export const ProviderDetailTabs = {
  Overview: {
    id: 'overview',
    label: 'Overview'
  },
  BasicInfo: {
    id: 'basic-info',
    label: 'Basic Info'
  }
};

export const VerificationStatusLabel: ObjectType<string> = {
  Found: 'Found',
  Failed: 'Failed',
  NeedsReview: 'Review',
  NotFound: 'Not Found'
};

export const ProviderHistoryTypeLabel = {
  BoardCertification: 'Board Certification',
  Dataset: 'Dataset',
  DeaRegistration: 'DEA',
  Files: 'Files',
  License: 'License',
  Notes: 'Notes',
  Npi: 'NPI',
  ProviderSettings: 'Provider Settings',
  RecordRemoved: 'Record Removed'
};

export const EnrolmentNetworkStatusLabel = {
  None: 'Network Status',
  Par: 'Par',
  NonPar: 'Non Par'
};

export const EnrolmentSpecialistTypeLabel = {
  None: 'Specialist Type',
  Pcp: 'Pcp',
  Specialist: 'Specialist'
};

export const EnrollmentStatusLabel = {
  None: 'All Enrollment Status',
  NotSubmitted: 'Not Submitted',
  Submitted: 'Submitted',
  Enrolled: 'Enrolled',
  Denied: 'Denied'
};

export const LocalStorageKey = {
  UserSession: 'verifier-user-session',
  RequestOpenForm: 'request-open-form',
  Announcement: 'verifier-announcement',
  CvoDismissedRecords: 'verifier-cvo-banner-dismissed-records',
  LicenseDismissedRecords: 'verifier-license-alert-dismissed-records'
};

export const RequestOpenFormTypes = {
  BasicInfo: 'BasicInfo',
  NewLicense: 'NewLicense',
  NewNpi: 'NewNpi',
  NewEducation: 'NewEducation',
  NewBoard: 'NewBoard',
  EditBoard: 'EditBoard'
};

export const CustomServiceErrorMessage: ObjectType<string> = {
  'Address is not valid.': 'Please enter a valid address.',
  alertId: 'Alert not found. Reason:'
};

export const EmptyLabelDefault = '--';

export const ProviderSearchPlaceholder = 'Name, Alias or NPI';

export const ProviderSearchNameAliasPlaceholder = 'Name or Alias';

export const PaginationFilterKey = 'page';

export const CursorFilterKey = 'cursor';

export const LicenseDisclaimer = [
  '3d1c90ef-20f6-44d0-a6bc-e7562e252a4b',
  '4ddbf5ed-6d8c-4928-91ea-c1ef78765ab0',
  // non simplified license type ids
  '26064268-e978-48f4-b48a-44d4c61fffc7',
  '71449865-b300-4c0b-8a35-f780ba7f9a9d'
];

export const NoLabelKey = '_nolabel_';

export const MonitoringErrors = [
  'Monitoring already enabled',
  'It looks like monitoring was already turned on'
];

export const DividerKey = '_DIVIDER_';

export const CaqhCacelPopupProps: ObjectType<string> = {
  title: 'Cancel CAQH merge?',
  desc: 'None of the CAQH information will be merged with this profile. You’ll need to re-import CAQH if you want to start a new merge.',
  okLabel: 'Yes, cancel merge',
  cancelLabel: 'No, don’t cancel'
};

export const ProileExistingRecordFoundPopupProps: ObjectType<string> = {
  title: 'Existing record found. Review items to be merged?',
  desc: 'This matches an existing record in Verifiable. Do you want to review the items that will be merged?',
  okLabel: 'Yes, review merge',
  cancelLabel: 'No, don’t review'
};

export const AmaMergeCommitConfirmPopupProps = {
  title: 'Complete merge without reviewing all items?',
  desc: 'Merging records that have not been reviewed yet will be replaced by AMA information.',
  okLabel: 'Yes, complete merge'
};

export const ProvidedInfoKey: ObjectType<string> = {
  AliasName: 'AliasName@@'
};
